import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { hasPermission, userHasPermission } from '../../../common/functions';
import permissionList from '../../../common/permissions';
import { UserContext } from '../../../containers/Context/UserContext';
import FollowButton from '../../Common/ActionButton/FollowButton';
import { strings } from '../../../assets/strings/all';
function CaseCardBottomAction(props) {
  const { common, cases } = strings;
  const {
    caseData: {
      uuid,
      slug,
      isFollowing,
      permissionArray,
      caseStatus: { slug: caseStatusSlug },
    },
    showButton,
    hovered,
  } = props;

  const { user } = useContext(UserContext);

  const { EDIT_MY_CASES_BASIC_DETAILS, PUBLISHED_CASE_REVIEW } = permissionList;
  const hasEditPermission = hasPermission(
    permissionArray,
    EDIT_MY_CASES_BASIC_DETAILS,
  );
  const hasReviewPermission = userHasPermission(user, PUBLISHED_CASE_REVIEW);
  return (
    <>
      {showButton === 'following' && isFollowing ? (
        hovered ? (
          <FollowButton
            uuid={uuid}
            className="no-br"
            addDataAfterRemove={props.addDataAfterRemove}
            isFollowing={isFollowing}
          />
        ) : (
          <Button variant="link" as={Link} to={`/cases/${slug}/edit`}>
            {cases.follow}
          </Button>
        )
      ) : (
        <></>
      )}

      {showButton === 'reviewComments' ? (
        <Button
          variant="primary"
          as={Link}
          to={`/cases/${slug}/review/comments`}
        >
          {cases.review_comments}
        </Button>
      ) : (
        <></>
      )}

      {showButton === 'edit' && hasEditPermission ? (
        <Button variant="link" as={Link} to={`/cases/${slug}/edit`}>
          {common.edit}
        </Button>
      ) : (
        <></>
      )}
      {showButton === 'review' &&
      hasReviewPermission &&
      caseStatusSlug === 'in-review' ? (
        <Button
          variant={!hovered ? 'link' : 'primary'}
          as={Link}
          to={`/cases/${slug}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {cases.review_cases}
        </Button>
      ) : (
        <></>
      )}
    </>
  );
}

export default CaseCardBottomAction;
